import api from "../utils/api";

import {
  GET_PROFILE_REQUEST,
  GET_PROFILE_SUCCESS,
  GET_PROFILE_FAIL,
  CLEAR_PROFILE,
  GET_PROFILES_SUCCESS,
  GET_PROFILES_FAIL,
  ACCOUNT_DELETE,
  ACCOUNT_DELETE_FAIL,
  GET_PROFILES_REQUEST,
} from "./constants/profile";
import { setAlert } from "./alertActions";

// Get current users profile
export const getCurrentProfile = () => async (dispatch: any) => {
  try {
    dispatch({ type: GET_PROFILE_REQUEST });

    const res = await api.get("/profile/me");

    dispatch({
      type: GET_PROFILE_SUCCESS,
      payload: res.data,
    });
  } catch (err: any) {
    dispatch({
      type: GET_PROFILE_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get all profiles
export const getProfiles = () => async (dispatch: any) => {
  dispatch({ type: GET_PROFILES_REQUEST });

  try {
    const res = await api.get("/profile");

    dispatch({
      type: GET_PROFILES_SUCCESS,
      payload: res.data,
    });
  } catch (err: any) {
    dispatch({
      type: GET_PROFILES_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get profile by ID
export const getProfileById = (userId: string) => async (dispatch: any) => {
  try {
    dispatch({ type: GET_PROFILE_REQUEST });
    const res = await api.get(`/profile/user/${userId}`);

    dispatch({
      type: GET_PROFILE_SUCCESS,
      payload: res.data,
    });
  } catch (err: any) {
    dispatch({
      type: GET_PROFILE_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Get profile by handle
export const getProfileByHandle = (handle: string) => async (dispatch: any) => {
  try {
    dispatch({ type: GET_PROFILE_REQUEST });
    const res = await api.get(`/profile/handle/${handle}`);

    dispatch({
      type: GET_PROFILE_SUCCESS,
      payload: res.data,
    });
  } catch (err: any) {
    dispatch({
      type: GET_PROFILE_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Create or update profile
export const createProfile = (
  formData: any,
  navigate?: any,
  edit: boolean = false
) => async (dispatch: any) => {
  try {
    const res = await api.post("/profile", formData);

    dispatch({
      type: GET_PROFILE_SUCCESS,
      payload: res.data,
    });

    dispatch(setAlert(edit ? "Profile Updated" : "Profile Created", "success"));

    if (!edit) {
      navigate("/dashboard");
    }
  } catch (err: any) {
    const errors = err.response.data.errors;

    if (errors) {
      errors.forEach((error: any) => dispatch(setAlert(error.msg, "danger")));
    }

    dispatch({
      type: GET_PROFILES_FAIL,
      payload: { msg: err.response.statusText, status: err.response.status },
    });
  }
};

// Delete account & profile
export const deleteAccount = () => async (dispatch: any) => {
  if (window.confirm("Are you sure? This can NOT be undone!")) {
    try {
      await api.delete("/profile");

      dispatch({ type: CLEAR_PROFILE });
      dispatch({ type: ACCOUNT_DELETE });

      dispatch(
        setAlert("Your account has been permanently deleted", "warning")
      );
    } catch (err: any) {
      dispatch({
        type: ACCOUNT_DELETE_FAIL,
        payload: { msg: err.response.statusText, status: err.response.status },
      });
    }
  }
};
